// extracted by mini-css-extract-plugin
module.exports = {"dataTable":"styles_dataTable__3OcU9","taskItem":"styles_taskItem__BfmdS","footerRow":"styles_footerRow__1SFRr","dataTableRowHeader":"styles_dataTableRowHeader__3YiLG"};